import { Urs, UrsActionType } from "./UrsSlice"
import { Box, Button, Paper, Stack, Typography } from "@mui/material"
import { Localized, useLocalization } from "@fluent/react"
import { DocumentKeyValueRow } from "../documents/utils/DocumentKeyValueRow";

interface UrsDetailsPanelProps {
    entity: Urs,
    editable: boolean,
    isUrsLinkAvail: (action: UrsActionType, urs: Urs) => boolean;
    handleEditUrsNumber: () => void;
    handleEditUrsLanguage: () => void;
    handleEditNumberingMode: () => void;
    handleEditSimpleDescriptionFieldClick: (field: 'purpose' | 'description' | 'area' | 'title', value: string) => void;
    handleEditDescriptionFieldClick: (field: 'purpose' | 'description' | 'area', value: string) => void;
}

export const UrsDetailsPanel = ({
    entity,
    editable,
    isUrsLinkAvail,
    handleEditUrsNumber,
    handleEditUrsLanguage,
    handleEditNumberingMode,
    handleEditSimpleDescriptionFieldClick,
    handleEditDescriptionFieldClick }: UrsDetailsPanelProps) => {

    const { l10n } = useLocalization();

    const numberingModeToFluentId: Record<string, string> = {
        UNIQUE_REQ: "urs-unique",
        DECIMAL_HIERARCHICAL: "urs-hierarchical",
    };

    const numberingModeId = numberingModeToFluentId[entity.documentNumberingMode];

    const numberingModeLabel = numberingModeId
        ? l10n.getString(numberingModeId)
        : entity.documentNumberingMode;

    return (
        <>
            <Paper elevation={1} sx={{ p: 1, mb: 1 }}>
                <Box>
                    <DocumentKeyValueRow
                        label={<Localized id="document-number-long">_number</Localized>}
                        value={entity.ursNo}
                        editable={isUrsLinkAvail("changeursnumber", entity)}
                        onEdit={handleEditUrsNumber}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="urs-title">_title</Localized>}
                        value={entity.title}
                        editable={isUrsLinkAvail("changeurstitle", entity)}
                        onEdit={() =>
                            handleEditSimpleDescriptionFieldClick("title", entity.title || "")}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="document-language">_language</Localized>}
                        value={entity.language}
                        editable={editable}
                        onEdit={handleEditUrsLanguage}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="urs-numbering-method">_numberingMethod</Localized>}
                        value={numberingModeLabel}
                        editable={editable}
                        onEdit={handleEditNumberingMode}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="urs-purpose">_Cel</Localized>}
                        value={<div dangerouslySetInnerHTML={{ __html: entity.purpose || "" }} />}
                        editable={editable}
                        onEdit={() =>
                            handleEditDescriptionFieldClick("purpose", entity.purpose || "")}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="urs-description">_description</Localized>}
                        value={<div dangerouslySetInnerHTML={{ __html: entity.description || "" }} />}
                        editable={editable}
                        onEdit={() =>
                            handleEditDescriptionFieldClick("description", entity.description || "")}
                    />
                    <DocumentKeyValueRow
                        label={<Localized id="urs-area">_area</Localized>}
                        value={<div dangerouslySetInnerHTML={{ __html: entity.area || "" }} />}
                        editable={editable}
                        onEdit={() =>
                            handleEditDescriptionFieldClick("area", entity.area || "")}
                    />

                </Box>

            </Paper>
        </>
    );
}
